import React, { type ReactNode } from 'react'
import { Navigate, Outlet } from 'react-router'
import { useAuthStore } from '@/stores/authStore'

interface PermissionRouteProps {
    element?: ReactNode
    requiredPermission?: string | string[]
    redirectTo?: string
    showUnauthorizedMessage?: boolean
}

export const PermissionRoute: React.FC<PermissionRouteProps> = ({
    element,
    requiredPermission,
    redirectTo = '/unauthorized',
    showUnauthorizedMessage = false,
}) => {

    const user = useAuthStore(state => state.user)
    const isAuthenticated = useAuthStore(state => state.isAuthenticated)

    // No autenticado → login
    if (!isAuthenticated) {
        return <Navigate to="/login" replace />
    }

    // Sin permiso específico → acceso permitido
    if (!requiredPermission) {
        return element ? <>{element}</> : <Outlet />
    }

    // Extraer permisos del usuario
    const userPermissions = user?.permissions ?? []

    const hasPermission = () => {
        if (Array.isArray(requiredPermission)) {
            // necesita TODOS los permisos
            return requiredPermission.every((perm) =>
                userPermissions.includes(perm)
            )
        }
        // necesita UNO
        return userPermissions.includes(requiredPermission)
    }

    if (hasPermission()) {
        return element ? <>{element}</> : <Outlet />
    }

    if (showUnauthorizedMessage) {
        console.error('No tienes permiso para acceder a esta página')
    }
    return <Navigate to={redirectTo} replace />
}
